module.exports = __webpack_public_path__ + "img/40_69_012_030.35f63479.jpg";